import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useRef } from "react";
import styled, { css, useTheme } from "styled-components";
import { Button, Grid, Icon, Text } from "~/components-shared";
const Wrapper = styled.div`
  position: relative;
  border-radius: ${_ref => {
  let {
    theme
  } = _ref;
  return theme.shape.borderRadius.primary;
}};
  ${_ref2 => {
  let {
    $border,
    $severity,
    theme
  } = _ref2;
  return $border && `border: 1px solid ${theme.colors[$severity]?.main}`;
}};
  background-color: ${_ref3 => {
  let {
    $severity,
    theme
  } = _ref3;
  return theme.colors[$severity]?.secondary;
}};
  color: ${_ref4 => {
  let {
    $severity,
    theme
  } = _ref4;
  return theme.colors[$severity]?.text;
}};
  ${_ref5 => {
  let {
    $fullWidth,
    $maxWidth
  } = _ref5;
  return $fullWidth && ($maxWidth === "initial" ? "width: 100%" : "width: 100vw");
}};
  ${_ref6 => {
  let {
    $maxWidth
  } = _ref6;
  return $maxWidth && `max-width: ${$maxWidth}`;
}};
  ${_ref7 => {
  let {
    $s,
    theme
  } = _ref7;
  return theme.spacing.resolve(theme, $s);
}};

  & > p {
    flex-grow: 1;
  }

  ${_ref8 => {
  let {
    $isSticky
  } = _ref8;
  return $isSticky && `position: sticky; top: 0; z-index: 1`;
}}
  ${_ref9 => {
  let {
    $shadow
  } = _ref9;
  return $shadow && css`
      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        transition: all 200ms ease-out;
        border-radius: ${_ref10 => {
    let {
      theme
    } = _ref10;
    return theme.shape.borderRadius.primary;
  }};
        box-shadow: ${_ref11 => {
    let {
      theme
    } = _ref11;
    return theme.shadows.large;
  }};
        z-index: -1;
      }
    `;
}}
`;
const Actions = styled.div`
  display: flex;
`;
const Timeout = styled.div`
  width: calc(100% - 8px);
  height: 2px;
  background-color: rgba(255, 255, 255, 0.2);
  overflow: hidden;
  border-radius: 2px;
  margin: 4px;
  position: relative;

  &:before {
    content: "";
    transition: width ${_ref12 => {
  let {
    timeout
  } = _ref12;
  return timeout;
}}ms linear;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 2px;
    border-radius: 2px;
    background-color: rgba(255, 255, 255, 0.5);
  }

  &.active:before {
    width: 0;
  }
`;
const Alert = _ref13 => {
  let {
    title,
    severity = "info",
    icon,
    actions = [],
    shadow = false,
    border = false,
    fullWidth = false,
    maxWidth = "initial",
    isSticky = false,
    timeout,
    onTimeout,
    s,
    children,
    ...rest
  } = _ref13;
  const {
    colors
  } = useTheme();
  const timeoutRef = useRef(null);
  const icons = {
    info: "infoOutline",
    grey: "infoOutline",
    warning: "warningOutline",
    danger: "errorOutline",
    success: "successOutline"
  };
  useEffect(() => {
    let t;
    if (timeout && typeof onTimeout === "function") {
      setTimeout(() => {
        timeoutRef.current?.classList.add("active");
      }, 10);
      t = setTimeout(onTimeout, timeout);
    }
    return () => {
      if (t) {
        clearTimeout(t);
      }
    };
  }, [timeout]);
  if (!children) {
    return null;
  }
  return /*#__PURE__*/React.createElement(Wrapper, _extends({
    $severity: severity,
    $fullWidth: fullWidth,
    $maxWidth: maxWidth,
    $shadow: shadow,
    $border: border,
    $isSticky: isSticky,
    $s: {
      p: 2,
      ...s
    }
  }, rest), /*#__PURE__*/React.createElement(Grid, {
    cols: 3,
    template: "auto 1fr auto"
  }, /*#__PURE__*/React.createElement(Icon, {
    src: icon || icons[severity],
    color: colors[severity]?.main,
    s: {
      my: 1.5,
      ml: 1
    },
    scale: 5,
    display: "block"
  }), /*#__PURE__*/React.createElement(Grid.Cell, {
    s: {
      py: 1.25,
      px: 2
    }
  }, title && /*#__PURE__*/React.createElement(Text, {
    element: "h6",
    lineHeight: 5.25,
    align: "left",
    s: {
      mb: 1
    }
  }, title), /*#__PURE__*/React.createElement(Text, {
    element: "p",
    lineHeight: 5.25,
    align: "left"
  }, children)), /*#__PURE__*/React.createElement(Grid.Cell, null, /*#__PURE__*/React.createElement(Actions, null, actions.map(action => /*#__PURE__*/React.createElement(Button, {
    key: action.icon,
    s: {
      p: 2
    },
    color: "transparent",
    rounded: true,
    onClick: action.onClick,
    outline: false
  }, /*#__PURE__*/React.createElement(Icon, {
    src: action.icon,
    display: "block",
    color: "inherit"
  })))))), timeout && typeof onTimeout === "function" && /*#__PURE__*/React.createElement(Timeout, {
    ref: timeoutRef,
    timeout: timeout
  }));
};
export default Alert;